/**
 * Design Token Values
 * Generated from tokens.ts - DO NOT EDIT DIRECTLY
 *
 * Use these for JavaScript/Canvas contexts where CSS variables don't work.
 * For DOM styling, prefer CSS variables or Tailwind classes.
 *
 * To modify tokens, edit: client/src/design-system/tokens/tokens.ts
 * Then run: pnpm generate:tokens
 */

export const tokenValues = {
    "color": {
        "accent": {
            "25": "#fdf8fc",
            "50": "#faf2f8",
            "100": "#f3cee8",
            "200": "#e69acc",
            "300": "#d36db9",
            "400": "#c248a9",
            "500": "#b1359b",
            "600": "#a0238c",
            "700": "#8a1d79",
            "800": "#6f155f",
            "900": "#5a1150"
        },
        "info": {
            "50": "#e6f7ff",
            "100": "#bae7ff",
            "200": "#91d5ff",
            "300": "#69c0ff",
            "400": "#40a9ff",
            "500": "#1677ff",
            "600": "#0958d9",
            "700": "#003eb3",
            "800": "#002c8c",
            "900": "#002766"
        },
        "red": {
            "50": "oklch(0.971 0.013 17.38)",
            "100": "oklch(0.936 0.032 17.717)",
            "200": "oklch(0.885 0.062 18.334)",
            "300": "oklch(0.808 0.114 19.571)",
            "400": "oklch(0.704 0.191 22.216)",
            "500": "oklch(0.637 0.237 25.331)",
            "600": "oklch(0.577 0.245 27.325)",
            "700": "oklch(0.505 0.213 27.518)",
            "800": "oklch(0.444 0.177 26.899)",
            "900": "oklch(0.396 0.141 25.723)",
            "950": "oklch(0.258 0.092 26.042)"
        },
        "orange": {
            "50": "oklch(0.98 0.016 73.684)",
            "100": "oklch(0.954 0.038 75.164)",
            "200": "oklch(0.901 0.076 70.697)",
            "300": "oklch(0.837 0.128 66.29)",
            "400": "oklch(0.75 0.183 55.934)",
            "500": "oklch(0.705 0.213 47.604)",
            "600": "oklch(0.646 0.222 41.116)",
            "700": "oklch(0.553 0.195 38.402)",
            "800": "oklch(0.47 0.157 37.304)",
            "900": "oklch(0.408 0.123 38.172)",
            "950": "oklch(0.266 0.079 36.259)"
        },
        "yellow": {
            "50": "oklch(0.987 0.026 102.212)",
            "100": "oklch(0.973 0.071 103.193)",
            "200": "oklch(0.945 0.129 101.54)",
            "300": "oklch(0.905 0.182 98.111)",
            "400": "oklch(0.852 0.199 91.936)",
            "500": "oklch(0.795 0.184 86.047)",
            "600": "oklch(0.681 0.162 75.834)",
            "700": "oklch(0.554 0.135 66.442)",
            "800": "oklch(0.476 0.114 61.907)",
            "900": "oklch(0.421 0.095 57.708)",
            "950": "oklch(0.286 0.066 53.813)"
        },
        "green": {
            "50": "oklch(0.982 0.018 155.826)",
            "100": "oklch(0.962 0.044 156.743)",
            "200": "oklch(0.925 0.084 155.995)",
            "300": "oklch(0.871 0.15 154.449)",
            "400": "oklch(0.792 0.209 151.711)",
            "500": "oklch(0.723 0.219 149.579)",
            "600": "oklch(0.627 0.194 149.214)",
            "700": "oklch(0.527 0.154 150.069)",
            "800": "oklch(0.448 0.119 151.328)",
            "900": "oklch(0.393 0.095 152.535)",
            "950": "oklch(0.266 0.065 152.934)"
        },
        "cyan": {
            "50": "oklch(0.984 0.019 200.873)",
            "100": "oklch(0.956 0.045 203.388)",
            "200": "oklch(0.917 0.08 205.041)",
            "300": "oklch(0.865 0.127 207.078)",
            "400": "oklch(0.789 0.154 211.53)",
            "500": "oklch(0.715 0.143 215.221)",
            "600": "oklch(0.609 0.126 221.723)",
            "700": "oklch(0.52 0.105 223.128)",
            "800": "oklch(0.45 0.085 224.283)",
            "900": "oklch(0.398 0.07 227.392)",
            "950": "oklch(0.302 0.056 229.695)"
        },
        "blue": {
            "50": "oklch(0.97 0.014 254.604)",
            "100": "oklch(0.932 0.032 255.585)",
            "200": "oklch(0.882 0.059 254.128)",
            "300": "oklch(0.809 0.105 251.813)",
            "400": "oklch(0.707 0.165 254.624)",
            "500": "oklch(0.623 0.214 259.815)",
            "600": "oklch(0.546 0.245 262.881)",
            "700": "oklch(0.488 0.243 264.376)",
            "800": "oklch(0.424 0.199 265.638)",
            "900": "oklch(0.379 0.146 265.522)",
            "950": "oklch(0.282 0.091 267.935)"
        },
        "violet": {
            "50": "oklch(0.969 0.016 293.756)",
            "100": "oklch(0.943 0.029 294.588)",
            "200": "oklch(0.894 0.057 293.283)",
            "300": "oklch(0.811 0.111 293.571)",
            "400": "oklch(0.702 0.183 293.541)",
            "500": "oklch(0.606 0.25 292.717)",
            "600": "oklch(0.541 0.281 293.009)",
            "700": "oklch(0.491 0.27 292.581)",
            "800": "oklch(0.432 0.232 292.759)",
            "900": "oklch(0.38 0.189 293.745)",
            "950": "oklch(0.283 0.141 291.089)"
        },
        "pink": {
            "50": "oklch(0.971 0.014 343.198)",
            "100": "oklch(0.948 0.028 342.258)",
            "200": "oklch(0.899 0.061 343.231)",
            "300": "oklch(0.823 0.12 346.018)",
            "400": "oklch(0.718 0.202 349.761)",
            "500": "oklch(0.656 0.241 354.308)",
            "600": "oklch(0.592 0.249 0.584)",
            "700": "oklch(0.525 0.223 3.958)",
            "800": "oklch(0.459 0.187 3.815)",
            "900": "oklch(0.408 0.153 2.432)",
            "950": "oklch(0.284 0.109 3.907)"
        },
        "gray": {
            "50": "#f9fafb",
            "100": "#f3f4f6",
            "200": "#e5e7eb",
            "300": "#d1d5db",
            "400": "#9ca3af",
            "500": "#6b7280",
            "600": "#4b5563",
            "700": "#374151",
            "800": "#1f2937",
            "900": "#111827"
        },
        "role": {
            "red": "#f5222d",
            "volcano": "#fa541c",
            "orange": "#fa8c16",
            "gold": "#faad14",
            "lime": "#a0d911",
            "green": "#52c41a",
            "cyan": "#13c2c2",
            "blue": "#1677ff",
            "geekblue": "#2f54eb",
            "purple": "#722ed1",
            "magenta": "#eb2f96",
            "grey": "#8c8c8c"
        },
        "white": "#ffffff",
        "status": {
            "success": "#059669",
            "warning": "#d97706",
            "danger": "#dc2626",
            "info": "#238ca0"
        },
        "entity": {
            "complaints": "#f5222d",
            "incidents": "#fa8c16",
            "obligations": "#1677ff",
            "controls": "#52c41a",
            "tests": "#722ed1",
            "risks": "#faad14",
            "attestations": "#2f54eb",
            "conflicts": "#eb2f96"
        },
        "chart": {
            "red": "#ff4d4f",
            "orange": "#ff9100",
            "yellow": "#f7d154",
            "green": "#00c853",
            "blue": "#0077c8",
            "purple": "#6f2da8",
            "pink": "#eb2f96",
            "grey": "#666666",
            "black": "#000000",
            "white": "#ffffff",
            "cyan": "#13c2c2",
            "indigo": "#5c6ac4",
            "lightRed": "#ff7875",
            "lightGold": "#ffc53d",
            "lightGreen": "#73d13d"
        },
        "chartCategorical": {
            "blue": "#0077c8",
            "orange": "#ff9100",
            "green": "#00c853",
            "purple": "#6f2da8",
            "gold": "#d4a017",
            "cyan": "#13c2c2",
            "other": "#666666"
        },
        "risk": {
            "low": "#52c41a",
            "mediumLow": "#95de64",
            "medium": "#ffa940",
            "mediumHigh": "#ff7875",
            "high": "#ff4d4f"
        },
        "trend": {
            "up": "#52c41a",
            "down": "#f5222d"
        },
        "ai": {
            "processing": "#8b5cf6"
        },
        "ui": {
            "scrollbarThumb": "rgba(0, 0, 0, 0.2)",
            "cardHeaderBg": "#fcfcfc",
            "cardBodyBg": "#ffffff",
            "border": "#d8dce2",
            "gold": "#fff3cd",
            "error": "#ff4d4f"
        },
        "hover": {
            "controls": "#73d13d",
            "warning": "#f59e0b",
            "danger": "#f87171"
        }
    },
    "semantic": {
        "primary": "#b1359b",
        "primaryHover": "#c248a9",
        "primaryActive": "#a0238c",
        "primaryLight": "#f3cee8",
        "foreground": "#111827",
        "mutedForeground": "#4b5563",
        "subtleForeground": "#676e7c",
        "quaternaryForeground": "#d1d5db",
        "placeholderForeground": "#676e7c",
        "background": "#f3f4f6",
        "card": "#ffffff",
        "popover": "#ffffff",
        "muted": "#f3f4f6",
        "cardHeaderBg": "#fcfcfc",
        "cardBodyBg": "#ffffff",
        "separator": "#d8dce2",
        "separatorSecondary": "#e5e7eb",
        "accent": "#b1359b",
        "tagClaim": "#c248a9",
        "statusError": "#dc2626",
        "statusNeutral": "#6b7280",
        "statusInfo": "#238ca0",
        "success": "#059669",
        "successSubtle": "#ecfdf5",
        "successBorder": "#a7f3d0",
        "successForeground": "#047857",
        "warning": "#d97706",
        "warningSubtle": "#fffbeb",
        "warningBorder": "#fde68a",
        "warningForeground": "#b45309",
        "danger": "#dc2626",
        "dangerSubtle": "#fef2f2",
        "dangerBorder": "#fecaca",
        "dangerForeground": "#b91c1c",
        "info": "#1677ff",
        "infoSubtle": "#e6f7ff",
        "infoBorder": "#91d5ff",
        "infoForeground": "#0958d9"
    },
    "spacing": {
        "xs": "4px",
        "sm": "8px",
        "md": "12px",
        "lg": "16px",
        "xl": "20px",
        "2xl": "24px",
        "3xl": "32px",
        "4xl": "48px"
    },
    "radius": {
        "sm": "4px",
        "base": "6px",
        "lg": "8px",
        "xl": "12px",
        "full": "9999px"
    },
    "typography": {
        "fontFamily": {
            "system": "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif",
            "mono": "ui-monospace, SFMono-Regular, \"SF Mono\", Menlo, Consolas, \"Liberation Mono\", monospace"
        },
        "fontSize": {
            "2xs": "11px",
            "xs": "12px",
            "sm": "14px",
            "base": "16px",
            "lg": "18px",
            "xl": "20px",
            "2xl": "24px",
            "3xl": "30px"
        },
        "avatarInitials": {
            "x-small": "7px",
            "small": "8px",
            "medium": "10px",
            "large": "12px"
        }
    },
    "shadow": {
        "sm": "0 1px 2px rgba(0, 0, 0, 0.05)",
        "md": "0 4px 6px rgba(0, 0, 0, 0.07)",
        "lg": "0 10px 15px rgba(0, 0, 0, 0.1)",
        "xl": "0 20px 25px rgba(0, 0, 0, 0.15)",
        "overlaySm": "0 0 0 1px rgba(0, 0, 0, 0.04), 0 4px 12px -2px rgba(0, 0, 0, 0.1)",
        "overlay": "0 0 0 1px rgba(0, 0, 0, 0.04), 0 12px 28px -8px rgba(0, 0, 0, 0.14)"
    },
    "dark": {
        "color": {
            "accent": {
                "25": "color-mix(in srgb, #b1359b 8%, transparent)",
                "50": "color-mix(in srgb, #b1359b 15%, transparent)",
                "100": "color-mix(in srgb, #b1359b 25%, transparent)",
                "200": "color-mix(in srgb, #b1359b 40%, transparent)",
                "300": "color-mix(in srgb, #b1359b 55%, transparent)",
                "400": "#c863b3",
                "500": "#b1359b",
                "600": "#d36db9",
                "700": "#e69acc",
                "800": "#f3cee8",
                "900": "#faf2f8"
            },
            "gray": {
                "50": "#1e2433",
                "100": "#2d3748",
                "200": "#4a5568",
                "300": "#718096",
                "400": "#a0aec0",
                "500": "#cbd5e0",
                "600": "#e2e8f0",
                "700": "#edf2f7",
                "800": "#f7fafc",
                "900": "#f7fafc"
            },
            "ui": {
                "scrollbarThumb": "rgba(255, 255, 255, 0.2)",
                "cardHeaderBg": "#2d3748",
                "cardBodyBg": "#1a202c",
                "border": "#4a5568"
            },
            "chartCategorical": {
                "blue": "#0077c8",
                "orange": "#d97400",
                "green": "#00a84f",
                "purple": "#9254de",
                "gold": "#ab7d0e",
                "cyan": "#0fa8a8",
                "other": "#7d8794"
            }
        },
        "semantic": {
            "foreground": "#f7fafc",
            "mutedForeground": "#cbd5e0",
            "subtleForeground": "#a0aec0",
            "quaternaryForeground": "#718096",
            "placeholderForeground": "#a0aec0",
            "background": "#0d1117",
            "card": "#1a202c",
            "popover": "#252d3d",
            "muted": "#1e2433",
            "cardHeaderBg": "#232b3b",
            "cardBodyBg": "#1a202c",
            "separator": "#3d4a5c",
            "separatorSecondary": "#2d3748",
            "success": "#34d399",
            "successSubtle": "color-mix(in srgb, #059669 18%, transparent)",
            "successBorder": "color-mix(in srgb, #059669 40%, transparent)",
            "successForeground": "#6ee7b7",
            "warning": "#fbbf24",
            "warningSubtle": "color-mix(in srgb, #d97706 18%, transparent)",
            "warningBorder": "color-mix(in srgb, #d97706 40%, transparent)",
            "warningForeground": "#fcd34d",
            "danger": "#f87171",
            "dangerSubtle": "color-mix(in srgb, #dc2626 18%, transparent)",
            "dangerBorder": "color-mix(in srgb, #dc2626 40%, transparent)",
            "dangerForeground": "#fca5a5",
            "info": "#69b1ff",
            "infoSubtle": "color-mix(in srgb, #1677ff 18%, transparent)",
            "infoBorder": "color-mix(in srgb, #1677ff 40%, transparent)",
            "infoForeground": "#91d5ff"
        },
        "shadow": {
            "sm": "0 0 0 1px rgba(255, 255, 255, 0.10), 0 2px 8px rgba(255, 255, 255, 0.06)",
            "md": "0 0 0 1px rgba(255, 255, 255, 0.10), 0 4px 16px rgba(255, 255, 255, 0.08)",
            "lg": "0 0 0 1px rgba(255, 255, 255, 0.10), 0 8px 24px rgba(255, 255, 255, 0.10)",
            "xl": "0 0 0 1px rgba(255, 255, 255, 0.10), 0 12px 32px rgba(255, 255, 255, 0.12)",
            "overlaySm": "0 0 0 1px rgba(255, 255, 255, 0.10), 0 4px 16px rgba(255, 255, 255, 0.08)",
            "overlay": "0 0 0 1px rgba(255, 255, 255, 0.10), 0 10px 28px rgba(255, 255, 255, 0.12)"
        }
    }
} as const;

export type TokenValues = typeof tokenValues;

// Convenience exports for common use cases

/**
 * Chart colors - Use for G2, AntV, and other chart libraries
 */
export const CHART_COLORS = tokenValues.color.chart;
export type ChartColor = keyof typeof CHART_COLORS;

/**
 * Risk colors - Use for risk matrix visualizations
 */
export const RISK_COLORS = tokenValues.color.risk;
export type RiskColor = keyof typeof RISK_COLORS;

/**
 * Entity colors - Use for domain-specific visualizations
 */
export const ENTITY_COLORS = tokenValues.color.entity;
export type EntityColor = keyof typeof ENTITY_COLORS;

/**
 * Status colors - Use for semantic status indicators
 */
export const STATUS_COLORS = tokenValues.color.status;
export type StatusColor = keyof typeof STATUS_COLORS;

/**
 * Ordered categorical chart palette per theme (canvas-safe concrete hexes).
 * Assign series colours by slot order and never cycle — fold extra categories into
 * "Other", which uses CHART_OTHER_COLOR (the semantic remainder colour, not a slot).
 */
export const CHART_CATEGORICAL = {
    light: [
        tokenValues.color.chartCategorical.blue,
        tokenValues.color.chartCategorical.orange,
        tokenValues.color.chartCategorical.green,
        tokenValues.color.chartCategorical.purple,
        tokenValues.color.chartCategorical.gold,
        tokenValues.color.chartCategorical.cyan,
    ],
    dark: [
        tokenValues.dark.color.chartCategorical.blue,
        tokenValues.dark.color.chartCategorical.orange,
        tokenValues.dark.color.chartCategorical.green,
        tokenValues.dark.color.chartCategorical.purple,
        tokenValues.dark.color.chartCategorical.gold,
        tokenValues.dark.color.chartCategorical.cyan,
    ],
} as const;

/**
 * Semantic remainder colour for "Other" / "Not recorded" / "Unassigned" chart groups.
 */
export const CHART_OTHER_COLOR = {
    light: tokenValues.color.chartCategorical.other,
    dark: tokenValues.dark.color.chartCategorical.other,
} as const;

/**
 * Traffic light color scheme for charts
 */
export const TRAFFIC_LIGHT_COLORS = {
    red: CHART_COLORS.red,
    orange: CHART_COLORS.orange,
    green: CHART_COLORS.green,
} as const;

/**
 * Traffic light range array for chart configurations
 */
export const TRAFFIC_LIGHT_RANGE = [
    TRAFFIC_LIGHT_COLORS.red,
    TRAFFIC_LIGHT_COLORS.orange,
    TRAFFIC_LIGHT_COLORS.green,
] as const;

// Legacy exports for backwards compatibility
export const CHART_COLORS_VALUES = CHART_COLORS;
export const RISK_COLORS_VALUES = RISK_COLORS;
